import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import PaymentIcon from "@mui/icons-material/Payment";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import { styled } from "@mui/material/styles";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: "3rem 2rem",
  textAlign: "center",
  maxWidth: "600px",
  margin: "0 auto",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
}));

const IconContainer = styled(Box)(({ theme }) => ({
  marginBottom: "1.5rem",
  "& .MuiSvgIcon-root": {
    fontSize: "4rem",
    color: theme.palette.primary.main,
    opacity: 0.7,
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  marginBottom: "1rem",
  fontWeight: 600,
  color: "#1e2420",
}));

const Description = styled(Typography)(({ theme }) => ({
  marginBottom: "2rem",
  color: "#656b74",
  lineHeight: 1.6,
}));

const ContactInfo = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.5rem",
  padding: "1rem",
  backgroundColor: "#f8f9fa",
  borderRadius: "8px",
  marginTop: "1rem",
  "& .MuiSvgIcon-root": {
    fontSize: "1.2rem",
    color: theme.palette.primary.main,
  },
}));

const PaymentRequired = () => {
  const { t } = useTranslation();
  const location = useLocation();

  // Get the type from query parameters
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type") || "default";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100vh - 8rem)",
        padding: "2rem",
      }}
    >
      <StyledPaper elevation={0} variant="outlined">
        <IconContainer>
          <PaymentIcon />
        </IconContainer>

        <Title variant="h4">{t("payment_required.title")}</Title>

        <Description variant="body1">{t(`payment_required.description.${type}`)}</Description>

        <ContactInfo>
          <ContactSupportIcon />
          <Typography
            variant="body2"
            sx={{
              color: "inherit",
            }}
          >
            {t("payment_required.help")}
          </Typography>
        </ContactInfo>
      </StyledPaper>
    </Box>
  );
};

export default PaymentRequired;
